/**
 * Hubert firepit state — lit / flaring, and which pinecones have been burned.
 *
 * Lives in a module map (like the rabbit and bird) so Friends switching and
 * re-entering the yard do not reset a lit fire or undo a burned pinecone.
 */

export type FirepitPhase = 'off' | 'lit' | 'flaring';

export interface FirepitState {
  phase: FirepitPhase;
}

/** Yards that currently have the interactive firepit toy. */
const FIREPIT_YARDS = new Set(['hubert']);

const firepits = new Map<string, FirepitState>();
const burnedPinecones = new Map<string, Set<string>>();

export function firepitStateForYard(yardId: string): FirepitState | null {
  if (!FIREPIT_YARDS.has(yardId)) return null;
  let state = firepits.get(yardId);
  if (!state) {
    state = { phase: 'off' };
    firepits.set(yardId, state);
  }
  return state;
}

export function burnedPineconeIdsForYard(yardId: string): ReadonlySet<string> {
  let set = burnedPinecones.get(yardId);
  if (!set) {
    set = new Set();
    burnedPinecones.set(yardId, set);
  }
  return set;
}

export function markPineconeBurned(yardId: string, pineconeId: string): void {
  const set = burnedPinecones.get(yardId) ?? new Set<string>();
  set.add(pineconeId);
  burnedPinecones.set(yardId, set);
}

export function resetFirepitStatesForTests(): void {
  firepits.clear();
  burnedPinecones.clear();
}
